import entity from '../../../models/loads/payments'

export default [
  {
    path: '/payments',
    meta: {
      entity,
      requiresPermissionTo: 'payments',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/payments/new',
    meta: {
      entity,
      requiresPermissionTo: 'payments',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/payments/:id',
    meta: {
      entity,
      requiresPermissionTo: 'payments',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
